import React, { FC, useContext, useEffect, useState } from 'react';

import ReactMarkdown from 'react-markdown';
import SwipeableViews from 'react-swipeable-views';

import { GlobalContext } from '../../../store';
import { IPage } from '../../../store/pages/store';
import { IClub } from '../../../store/player/clubs/store';

import Select from '../../../components/Select';

interface IOption {
  label: string;
  value: string;
  index: number;
}

interface IProps {
  club: IClub;
  clubId: number;
}

const ClubStaticPages: FC<IProps> = props => {
  const { club, clubId } = props;

  const {
    actions: {
      pages: { get: getPages }
    },
    pages
  } = useContext(GlobalContext);

  const [active, setActive] = useState(0);
  const [clubPages, setClubPages] = useState<IPage[]>([]);
  const [options, setOptions] = useState<IOption[]>([]);

  const select = (selected: { value: number; index: number }): void => {
    setActive(selected.index);
  };

  useEffect(() => {
    getPages(Number(clubId), false, false);
  }, [clubId]);

  useEffect(() => {
    const newClubPages = pages[clubId];

    if (newClubPages) {
      setClubPages(newClubPages);
    }
  }, [pages, clubId]);

  useEffect(() => {
    const newOptions = clubPages.map((item: IPage, index: number) => ({
      index,
      label: item.name || '',
      value: String(item.id)
    }));

    setOptions(newOptions);
  }, [clubPages]);

  return (
    <div className="club-static-pages">
      {pages && club && options.length > 0 ? (
        <div>
          <Select title="FILTER" options={options} onSelect={select} />

          <SwipeableViews
            animateHeight={true}
            disabled={true}
            enableMouseEvents={false}
            axis={'x'}
            index={Number(active)}
            className="static-pages-container"
          >
            {clubPages.map((item: IPage, index: number) => (
              <div key={index} className={`static static-page-${item.id}`}>
                <ReactMarkdown source={item.content} className="markdown" />
              </div>
            ))}
          </SwipeableViews>
        </div>
      ) : (
        <div className="empty-item">There are no items to show in this category</div>
      )}
    </div>
  );
};

export default ClubStaticPages;
